import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    chatList: {
        requesting: false,
        items: [],
        error: null,
        success: false,
        filters: {},
    },

    chatDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null,
    },
    
    chatMembers: {
        requesting: false,
        error: null,
        success: false,
        items: [],
    },

    chatMessages: {
        requesting: false,
        error: null,
        success: false,
        items: [],
    },
  };

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    getChatList: (state, action) => {
        state.chatList.requesting = true;
        state.chatList.error = null;
        state.chatList.items = [];
        state.chatList.success = false;
        state.chatList.filters = action.payload;
    },
    getChatListSuccess: (state, action) => {
        state.chatList.requesting = false;        
        state.chatList.items = action.payload;
        state.chatList.success = true; 
    },
    getChatListFail: (state, action) => {        
        state.chatList.requesting = false;
        state.chatList.error = action.payload;
    },
    getChatDetails: (state) => {
        state.chatDetails.requesting = true;
        state.chatDetails.error = null;
        state.chatDetails.data = null;
        state.chatDetails.success = false; 
    },
    getChatDetailsSuccess: (state, action) => {
        state.chatDetails.requesting = false;
        state.chatDetails.data = action.payload;
        state.chatDetails.success = true; 
    },
    getChatDetailsFail: (state, action) => {        
        state.chatDetails.requesting = false;
        state.chatDetails.error = action.payload;
    },
    doChatCreate: (state) => {
        state.chatDetails.requesting = true;
        state.chatDetails.error = null;
        state.chatDetails.data = null;
        state.chatDetails.success = false; 
    },
    doChatUpdate: (state) => {
        state.chatDetails.requesting = true;
        state.chatDetails.error = null;
        state.chatDetails.data = null;
        state.chatDetails.success = false; 
    },
    doChatDelete: (state) => {
        state.chatDetails.requesting = true;
        state.chatDetails.error = null;
        state.chatDetails.data = null;
        state.chatDetails.success = false; 
    },

    getChatMembers: (state) => {
        state.chatMembers.requesting = true;
        state.chatMembers.error = null;
        state.chatMembers.items = [];
        state.chatMembers.success = false; 
    },
    getChatMembersSuccess: (state, action) => {
        state.chatMembers.requesting = false;
        state.chatMembers.items = action.payload;
        state.chatMembers.success = true; 
    },
    getChatMembersFail: (state, action) => {        
        state.chatMembers.requesting = false;
        state.chatMembers.error = action.payload;
    },

    getChatMessages: (state) => {
        state.chatMessages.requesting = true;
        state.chatMessages.error = null;
        state.chatMessages.items = [];
        state.chatMessages.success = false; 
    },
    getChatMessagesSuccess: (state, action) => {
        state.chatMessages.requesting = false;
        state.chatMessages.items = action.payload;
        state.chatMessages.success = true; 
    },
    getChatMessagesFail: (state, action) => {        
        state.chatMessages.requesting = false;
        state.chatMessages.error = action.payload;
    },

  },
})

export const { 
    getChatList, getChatListSuccess, getChatListFail,
    getChatDetails, getChatDetailsSuccess, getChatDetailsFail,
    doChatCreate, doChatUpdate, doChatDelete,
    getChatMembers, getChatMembersSuccess, getChatMembersFail,
    getChatMessages, getChatMessagesSuccess, getChatMessagesFail,
} = chatSlice.actions

export default chatSlice.reducer